export default __webpack_public_path__ + "static/data-points-bg-min-0530d56a66721d79bfdb471babdabe0b.png";